import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionProps {
    children: ReactNode;
    className?: string;
    container?: boolean;
}

export function Section({ children, className, container = true }: SectionProps) {
    return (
        <section className={cn('py-20 lg:py-28', className)}>
            {container ? (
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>
            ) : (
                children
            )}
        </section>
    );
}

interface SectionHeaderProps {
    title: string;
    highlight?: string;
    description?: string;
    className?: string;
    align?: 'center' | 'left';
}

export function SectionHeader({ title, highlight, description, className, align = 'center' }: SectionHeaderProps) {
    return (
        <div className={cn(
            'mb-16',
            align === 'center' && 'text-center',
            className
        )}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
                {title}{' '}
                {highlight && <span className="text-gradient">{highlight}</span>}
            </h2>
            {description && (
                <p className={cn(
                    'mt-4 text-lg text-muted-foreground',
                    align === 'center' && 'max-w-2xl mx-auto'
                )}>
                    {description}
                </p>
            )}
        </div>
    );
}
